import $api from '../services';

export default {
    getSetupIntent() {
        return $api.get('/add_setupIntent');
    },
    setDefaultPayment(params) {
        return $api.post('/set_default_payment', params);
    },
    getPaymentMethod() {
        return $api.get('/saved_payment_methods');
    },
    getSubscriptionsList() {
        return $api.get('/subscriptions');
    },
    subscribeOnDataset(params) {
        return $api.post('/subscribe', params);
    },
    deleteCard(params) {
        return $api.post('/delete_payment_method', params);
    },
};
